import React from 'react';
import logoImage from '../../../shared/img/Logo_Onboarding.svg';
import { makeStyles } from '@material-ui/core/styles';

const Logo = (props) => {

  const classes = useStyles();

  return (
    <div className={props.className}>
      <img src={logoImage} className={classes.imagem} alt="Logo" />
    </div>
  );
}

const useStyles = makeStyles({
  imagem: {
    width: '100%'
  }
});

export default Logo;